import Splide from "@splidejs/splide";

export default class SplideFvSlider {
  constructor(selector) {
    this.selector = selector;
    this._init();
  }

  _init() {
    const el = document.querySelector(this.selector);
    if (!el) return;

    const target_options = {
      type: "fade",
      rewind: true,
      autoplay: true,
      arrows: false,
      pagination: true,
      interval: 7000,
      speed: 3500,
      pauseOnHover: false,
    };

    new Splide(el, target_options).mount();
  }
}
